import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import Icon from "../images/logo.svg"
import { Link } from "gatsby"

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          menuLinks {
            name
            link
          }
        }
      }
    }
  `)
  return (
    <HeaderMenu>
      <Link to="/">
        <Icon height="50" alt="tilbake til forsiden" />
      </Link>
      <nav>
        <LinkContainer>
          {data.site.siteMetadata.menuLinks.map(item => (
            <li key={item.name}>
              <Link to={item.link} activeClassName="active">
                {item.name}
              </Link>
            </li>
          ))}
        </LinkContainer>
      </nav>
    </HeaderMenu>
  )
}

const LinkContainer = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;

  li {
    padding: 5px;
    margin: 0;
    align-self: center;
    margin-left: 0px;
  }

  li a {
    color: #00679b;
    text-decoration: none;
    font-size: 14px;
  }

  @media (min-width: 760px) {
    li a {
      font-size: 16px;
    }
    li {
      margin-left: 25px;
    }
  }

  .active,
  li a:hover,
  li a:focus {
    text-decoration: underline;
  }
`

const HeaderMenu = styled.header`
  width: 100%;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 0;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0px 1px 5px 0px #0000001f;

  nav {
    display: flex;
  }

  svg {
    padding: 5px;
    height: 28px;
    margin-left: -15px;
  }

  li {
    padding: 0px 5px;
  }

  a {
    display: flex;
  }

  @media (min-width: 760px) {
    svg {
      height: 50px;
    }

    ul {
      margin-right: 25px;
    }
  }
`

export default Header
